import { RootAppState } from 'store/types';

export const getAccessibilitySettings = (state: RootAppState) => state.accessibility;
export const isContrastTheme = (state: RootAppState) => state.accessibility.isContrastTheme;
